<template>
  <div id="full">
    <div id="app">
    <!-- styleを入れておかないと高さが付く -->
    <vs-alert color="" active="" style="height:60px" class="pc">
      <nav>
        <router-link to="/Home"><vs-button :color="colorx" :gradient-color-secondary="colorx2" type="gradient"><font-awesome-icon icon="home" size="lg"/> home</vs-button></router-link>
        <router-link to="/Work"><vs-button :color="colorx" :gradient-color-secondary="colorx2" type="gradient"><font-awesome-icon icon="pen" size="lg"/> work</vs-button></router-link>
        <router-link to="/Skill"><vs-button :color="colorx" :gradient-color-secondary="colorx2" type="gradient"><font-awesome-icon icon="code" size="lg"/> skill</vs-button></router-link>
        <router-link to="/Contact"><vs-button :color="colorx" :gradient-color-secondary="colorx2" type="gradient"><font-awesome-icon icon="envelope" size="lg"/> contact</vs-button></router-link>
        <img class="round float roll" src="@/image/chobi.png" width=50px>
      </nav>
    </vs-alert>
    
    <vs-alert color="" active="" style="height:60px" class="responsive">
      <nav>
        <router-link to="/Home"><vs-button :color="colorx" :gradient-color-secondary="colorx2" type="gradient" style="width: 50px"><font-awesome-icon icon="home" size="lg"/></vs-button></router-link>
        <router-link to="/Work"><vs-button :color="colorx" :gradient-color-secondary="colorx2" type="gradient" style="width: 50px"><font-awesome-icon icon="pen" size="lg"/></vs-button></router-link>
        <router-link to="/Skill"><vs-button :color="colorx" :gradient-color-secondary="colorx2" type="gradient" style="width: 50px"><font-awesome-icon icon="code" size="lg"/></vs-button></router-link>
        <router-link to="/Contact"><vs-button :color="colorx" :gradient-color-secondary="colorx2" type="gradient" style="width: 50px"><font-awesome-icon icon="envelope" size="lg"/></vs-button></router-link>
        <img class="round float roll" src="@/image/chobi.png" width=50px>
      </nav>
    </vs-alert>


    <router-view />

    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  data(){
    return {
      colorx:'rgb(0, 136, 255)',
      colorx2:'rgb(0, 42, 255)'
    }
  },
  components: {
  }
}
</script>

<style>
/* @import "css/style.css"; */

@import url('https://fonts.googleapis.com/css2?family=Comic+Neue:ital,wght@1,700&display=swap');

#full {
  /* フルスクリーン用ボーダー */
  margin: auto;
  margin-top: 2%;
  width: 80vw;
  height: 90vh;
  border: double 10px #0073ff57;
}

.float {
  float: right;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* 文字色 */
  color: #2c3e50;
  /* ボックスセンター */
  margin: auto;
  /* 左右の余白作り */
  max-width: 90%;
}

h1,h3,p,a,span {
  /* cursiveは筆記体 */
  /* font-family: 'Comic Neue', cursive; */
  font-family: 'Lato', 'Noto Sans JP', 'ヒラギノ角ゴ ProN', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
}

h1 {
  padding-top: 0;
}

p {
  /* font-family: 'Comic Neue', cursive; */
  /* 文字の上下間隔 */
  line-height: 150%;
}

.profile-img{
	margin: 30px 0px;
}

nav {
    /* display: flex; */
    align-items: center;
    height: 50px;
    /* background: #222; */
}
/* ボタン幅 nav aには効かないため */
.vs-button {
  margin-right: 20px;
  height: 50px;
}
nav a {
    /* display: block; */
    padding: 0;
    line-height: 1em;
    text-decoration: none;
    color: white;
}
/* アクティブなリンク */
.router-link-active {
    /* background: rgba(18, 172, 214, 0.272); */
    color: rgb(34, 34, 34);
}

.animation-wrap {
  /* nav バーからの余白 */
  margin-top: 20px;
  animation: animation-wrap 2s cubic-bezier(0.54, 0.54, 1, 1.02);
}

@keyframes animation-wrap {
  0% {
    clip-path: circle(0 at 50% 50%);
    -webkit-clip-path: circle(0 at 50% 50%);
  }
  100% {
    clip-path: circle(100% at 50% 50%);
    -webkit-clip-path: circle(100% at 50% 50%);
  }
}

.roll {
  animation: r7 5s linear infinite;
}
 
@keyframes r7 {
  0%   { transform: rotateY(0deg); }
  100% { transform: rotateY(360deg); }
}

.list-wrap {
  max-width: 40%;
  margin: auto;
}

.vs-list {
  text-align: left;
  /* display: flex; */
}

.responsive{
  display: none;
}

/* 

タブレット用  CSS 

*/
@media (max-width: 768px) {

  #full {
  margin: auto;
  margin-top: 1%;
  width: 98vw;
  height: 86vh;
  border: double 10px #0073ff57;
  /* background-color: rgba(218, 218, 218, 0.088); */
}

  .animation-wrap {
  /* nav バーからの余白 */
  margin-top: 10px;
  }
  
  h1 {
  font-size: 1.4em;
  }

  p {
    font-size: 15px;
  }  
  .display-none {
    display: none;
  }
  .vs-button {
    margin-right: 5px;
  }

  element.style {
    box-shadow: 0px 0px 25px 0px;
    height: 0px;
  }

     .pc{
    display: none;
  }
  .responsive{
    display: inline;
  }

  .list-wrap {
  max-width: 100%;
  margin: auto;
  }

  .profile-img{
	margin: 15px 0px;
  width: 250px;
}

}

</style>



// WEBPACK FOOTER //
// src/App.vue